import React from 'react'

import {
  AdminPillVariant,
  OwnerPillVariant,
  FinancePillVariant,
} from 'components/Pill'
import { StyledPill } from './MemberBadge.styles'

export type BadgeType =
  | 'super-admin'
  | 'admin'
  | 'owner'
  | 'pending-invite'
  | 'finance'

export const BADGE_PROPS_BY_TYPE = {
  'super-admin': {
    color: 'orange',
    children: 'Super Admin',
  },
  owner: {
    color: 'teal',
    children: 'owner',
    variant: OwnerPillVariant,
  },
  admin: {
    color: 'indigo',
    children: 'admin',
    variant: AdminPillVariant,
  },
  'pending-invite': {
    color: 'orange',
    children: 'Pending',
    variant: { kind: 'secondary' },
  },
  finance: {
    color: 'indigo',
    children: 'finance',
    variant: FinancePillVariant,
  },
} as const

interface MemberBadgeProps {
  badge: BadgeType
}

const MemberBadge: React.FC<MemberBadgeProps> = ({ badge }) => {
  return <StyledPill {...BADGE_PROPS_BY_TYPE[badge]} />
}

export default MemberBadge
